function normalizeBasePath(value: string | undefined): string {
  const raw = (value ?? '/').trim();
  if (raw === '' || raw === '/') {
    return '/';
  }

  const withLeading = raw.startsWith('/') ? raw : `/${raw}`;

  return withLeading.endsWith('/') ? withLeading : `${withLeading}/`;
}

export const appConfig = {
  /** Vite `base` — e.g. `/employee/` when embedded in Laravel. */
  basePath: normalizeBasePath(import.meta.env.BASE_URL),

  /** Same UI as mobile, hosted at /employee on the HR domain. */
  isEmployeeWeb: import.meta.env.VITE_APP_VARIANT === 'employee-web',

  /** Hide manager/HR team tabs on employee web (self-service only). */
  selfServiceOnly: import.meta.env.VITE_SELF_SERVICE_ONLY === 'true',

  /** Resolved API origin (empty env → current page origin). */
  apiOrigin: (import.meta.env.VITE_API_URL ?? '').trim(),
};

export function resolveApiOrigin(): string {
  if (appConfig.apiOrigin) {
    return appConfig.apiOrigin.replace(/\/$/, '');
  }

  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin;
  }

  return '';
}
